import { Controller } from 'stimulus';
export default class extends Controller {
  static targets = ['dropdown'];

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClickGoBack = this.handleClickGoBack.bind(this);
  }

  toggle() {
    const isMenuHidden = this.dropdownTarget.classList.toggle('is-hidden');
    if (!isMenuHidden) {
      document.addEventListener('mousedown', this.handleClickOutside);
    } else {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  handleClickOutside = e => {
    if (
      !this.dropdownTarget.contains(e.target) &&
      !this.element
        .querySelector('.mobile-app-header__icon-menu')
        .contains(e.target)
    ) {
      if (!this.dropdownTarget.classList.contains('is-hidden')) {
        this.dropdownTarget.classList.add('is-hidden');
        document.removeEventListener('mousedown', this.handleClickOutside);
      }
    }
  };

  handleClickGoBack = e => {
    e.preventDefault();
    e.stopPropagation();

    if (window.Sofatutor && window.Sofatutor.MobileApp) {
      const appEvent = window.Sofatutor.MobileApp.createEvent('goBack');

      if (typeof window.Sofatutor.MobileApp.sendEvent === 'function') {
        window.Sofatutor.MobileApp.sendEvent(appEvent);
      } else {
        // eslint-disable-next-line no-console
        console.error('window.Sofatutor.MobileApp.sendEvent is not defined');
      }
    }
  };
}
